export const queryParamConstants = {
  secureClientIdKeyOne: '$1'
};
